import type * as React from "react"
import "./ErrorState.css"

export interface ErrorStateProps {
  readonly title?: string
  readonly detail?: string
  /** Retry affordance; rendered only when provided. */
  readonly onRetry?: () => void
  readonly retryLabel?: string
  readonly children?: React.ReactNode
}

/**
 * The shared visual for failure surfaces: route error components, error
 * boundary fallbacks, empty-because-broken panels. One idiom so a failure
 * looks the same everywhere and always offers a way forward.
 */
export function ErrorState({
  title = "Something went wrong",
  detail,
  onRetry,
  retryLabel = "Try again",
  children
}: ErrorStateProps) {
  return (
    <div className="FfnErrorState" role="alert">
      <h2 className="FfnErrorStateTitle">{title}</h2>
      {detail !== undefined && <p className="FfnErrorStateDetail">{detail}</p>}
      {children}
      {onRetry !== undefined && (
        <button type="button" className="FfnButton" data-variant="default" onClick={onRetry}>
          {retryLabel}
        </button>
      )}
    </div>
  )
}
